import { Component } from 'react'
import './resource.css'

class TBD extends Component {

    render() {
        return <div className={`Res-Container Res-Default`}>
            <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div>
        </div>
    }
}

export default TBD